var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('UnableToOfferHeader',{staticClass:"px-10 m:px-0"}),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }